var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.displayDropdown
        ? _c("dropdown", {
            scopedSlots: _vm._u(
              [
                {
                  key: "triggerbutton",
                  fn: function() {
                    return [
                      _vm.hasChip
                        ? _c("span", {
                            class: "chip chip-" + _vm.chipColor(_vm.chip)
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "gray-100 m-0",
                          on: { mouseover: _vm.fetch }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.label) +
                              "\n            "
                          )
                        ]
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "content",
                  fn: function() {
                    return [
                      _vm.loader
                        ? _c(
                            "div",
                            {
                              staticClass: "absolute-center absolute-full-width"
                            },
                            [
                              _c("preloader", {
                                staticClass: "loader-small",
                                attrs: { display: _vm.loader }
                              })
                            ],
                            1
                          )
                        : _c("div", [
                            _c(
                              "div",
                              { staticClass: "content-header" },
                              [
                                _c(
                                  "h4",
                                  {
                                    staticClass:
                                      "content-header__title typographies-paragraph-medium-bold"
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(_vm.label) +
                                        "\n                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.object === "tasks"
                                  ? _c("CompassButton", {
                                      attrs: {
                                        label: _vm.$t.__(
                                          "listing.ListingDropdown.plan_task"
                                        ),
                                        type: "tertiary"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.addTask(
                                            _vm.relatedid,
                                            _vm.linkedType,
                                            _vm.step
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "ul",
                              _vm._l(_vm.data.elements, function(
                                element,
                                elementIndex
                              ) {
                                return _c(
                                  "li",
                                  {
                                    key: elementIndex,
                                    staticClass: "bt-1-lightgrey"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        class:
                                          "py-2 px-3 chip-border chip-border--" +
                                          _vm.borderChip(element.chip)
                                      },
                                      [
                                        _c("p", {
                                          staticClass: "semibold ellipsis",
                                          domProps: {
                                            innerHTML: _vm._s(element.bottom)
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("p", {
                                          class: [
                                            element.chip === "error"
                                              ? "red"
                                              : "gray-60"
                                          ],
                                          domProps: {
                                            innerHTML: _vm._s(element.top)
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ])
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1886710460
            )
          })
        : _c("span", [_vm._v(_vm._s(_vm.placeholder))])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }